var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"items":_vm.items,"outlined":"","dense":"","label":_vm.label},on:{"input":function($event){return _vm.$emit('input', _vm.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }